import repair1 from "../../../../images/content/pillar-1/use-and-consumption/repair1.svg";
import repair2 from "../../../../images/content/pillar-1/use-and-consumption/repair2.svg";
import repair3 from "../../../../images/content/pillar-1/use-and-consumption/repair3.svg";
import repair4 from "../../../../images/content/pillar-1/use-and-consumption/repair4.svg";

export const repairImages = [
	{
		id: "repair-image-1",
		imageUrl: repair1,
		imageAlt: "276,5 million units placed on the market in 2023",
	},
	{
		id: "repair-image-2",
		imageUrl: repair2,
		imageAlt: "1,6 billion euros industry turnover for repair and service",
	},
	{
		id: "repair-image-3",
		imageUrl: repair3,
		imageAlt: "95% repair requests actually repaired",
	},
	{
		id: "repair-image-4",
		imageUrl: repair4,
		imageAlt: "24250 business partners in repair and after-sale services",
	},
];